import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { debounce } from 'lodash-es';
import townApi from '~/core/components/TownSelect/api';
import { DIALOG_MESSAGE as CORE_DIALOG } from '~/core/constants';
import useMainDialogStore from '~/stores/useMainDialogStore';
export var useTownSearch = function useTownSearch(_ref) {
  var searchQuery = _ref.searchQuery,
    onError = _ref.onError;
  var $dialog = useMainDialogStore();
  var loading = ref(false);
  var towns = ref([]);
  var currentRequestTime = ref(0);
  watch(searchQuery, function (val) {
    return handleSearchInput(val);
  });
  function onSearchInput(_x) {
    return _onSearchInput.apply(this, arguments);
  }
  function _onSearchInput() {
    _onSearchInput = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(query) {
      var innerTime, _yield$townApi$get, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(Number(query === null || query === void 0 ? void 0 : query.length) > 100)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            innerTime = Date.now();
            currentRequestTime.value = innerTime;
            loading.value = true;
            _context.prev = 5;
            _context.next = 8;
            return townApi.get(query);
          case 8:
            _yield$townApi$get = _context.sent;
            data = _yield$townApi$get.data;
            if (!(innerTime !== currentRequestTime.value)) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return");
          case 12:
            towns.value = data;
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](5);
            onError ? onError(_context.t0) : $dialog.open(_objectSpread({}, CORE_DIALOG.GLOBAL_ERROR));
          case 18:
            _context.prev = 18;
            loading.value = false;
            return _context.finish(18);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 15, 18, 21]]);
    }));
    return _onSearchInput.apply(this, arguments);
  }
  var handleSearchInput = debounce(function (query) {
    return onSearchInput(query);
  }, 200);
  return {
    towns: towns,
    loading: loading,
    forceSearch: onSearchInput
  };
};